import React, { useEffect, useState } from "react";
import BarChartComponent from "../component/BarChartCompoent";
import { AssessmentData } from "../interface/ScoreResponse_Interface";
import { useApi } from "../../../../service/ApiContext";
import { LocalStorage } from "../../../../utils/Utils";
import NoAssessmentPage from "../../industry_score/pages/NoAssessmentPages";

interface SkillScorePageProps {
  data: AssessmentData;
}

const SkillScorePage: React.FC<SkillScorePageProps> = ({ data }) => {
  const [scoreCandidate, setScoreCandidate] = useState<AssessmentData | null>(
    data,
  );

  // Fetching data logic, use useEffect to trigger data loading if necessary
  useEffect(() => {
    if (data) {
      setScoreCandidate(data); // If data prop is passed, set it in state
    }
  }, [data]); // Re-run the effect when the `data` prop changes

  return (
    <div
      style={{
        overflow: "auto",
        width: "100%",
        height: "70vh",
        marginTop: "30px",
        marginBottom: "0px",
      }}
    >
      {data.skill_report.length === 0 ? (
        <NoAssessmentPage />
      ) : (
        scoreCandidate && <BarChartComponent datas={scoreCandidate} />
      )}
    </div>
  );
};

export default SkillScorePage;
